/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { asyncScheduler, merge, Subscription } from 'rxjs';
import { filter, observeOn, tap } from 'rxjs/operators';
import { OptionMultiSelectionService } from '../../option/selection/multi-selection/option-multi-selection.service';
import { AutocompleteComponent } from '../autocomplete.component';
import { OptionHoverService } from '../../option/option-hover.service';

@Component({
    selector: 'ngf-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    standalone: false
})
export class MultiSelectComponent implements OnInit, OnDestroy {

  constructor(public autocomplete: AutocompleteComponent,
              private optionService: OptionMultiSelectionService,
              private hoverService: OptionHoverService) {}

  private sub: Subscription;

  @Input()
  ariaLabelledby?: string;

  @Input()
  ariaDescribedby?: string;

  ngOnInit(): void {
    this.sub = merge(
      this.handleSelectionChange$(),
      this.handleWrittenValueChanged$()
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  handleSearch(search: string): void {
    this.autocomplete.handleSearch(search);
    // Clear hover state when search changes to avoid stale references to destroyed options
    this.hoverService.hover(null);
  }

  handleToggle() {
    this.autocomplete.optionsOverlay.toggle();
  }

  private handleSelectionChange$() {
    return this.optionService.selection$.pipe(
      observeOn(asyncScheduler),
      filter(selection => selection.userInput),
      tap(selection => {
        this.autocomplete.handleSelection(selection.values);
        this.autocomplete.onTouched();
      })
    );
  }

  private handleWrittenValueChanged$() {
    return this.autocomplete.writtenValue$.pipe(
      tap(values => this.optionService.selectAll({values, userInput: false}))
    );
  }
}
